import { render, staticRenderFns } from "./NeoparentHome.vue?vue&type=template&id=766a4aef&scoped=true"
import script from "./NeoparentHome.vue?vue&type=script&lang=js"
export * from "./NeoparentHome.vue?vue&type=script&lang=js"
import style0 from "./NeoparentHome.vue?vue&type=style&index=0&id=766a4aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a4aef",
  null
  
)

export default component.exports